module.exports = __webpack_public_path__ + "static/img/huifeng.ac6996d8.png";